module.exports = {
	init() {
		this.list = this.root.querySelector('.social-list');
		this.shareBtn = this.root.querySelector('.share-button');
		this.initEvents();
	},
	initEvents() {
		this.shareBtn.addEventListener('click', this.toggleList.bind(this));
	},
	toggleList() {
		this.list.classList.toggle('show');
	},
};
